module.exports = window["Bernie_l10nBundle_ar_SA"];